import { z } from 'zod';

import { ObsoleteBlockFormFields } from './FormFields';
import { type BlockConfigProps } from '../../types';

export const obsoleteNodeConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'obsolete',
  defaultConfig: {},
  configFields: {
    schema: z.object({}),
    FormFields: ObsoleteBlockFormFields,
  },
  documentationMarkdown: 'Obsolete block',
};
